import { UserRole } from "types/user.type";

export const roleColors: Record<UserRole, string> = {
  super_admin: "gold",
  admin: "#1976d2",
  manager: "#2e7d32",
  employee: "#616161",
};
